import type { IControlSettingUI, IRMetricKey } from '../../type';

import { EControlType, EReportControlId } from '../../type';
import { REPORT_METRIC_INFO } from '../constants';

export const getMetricSettingUI = (uid: IRMetricKey, label: string): IControlSettingUI => {
  return {
    id: EReportControlId.METRIC,
    uid,
    type: EControlType.SELECT_INLINE,
    label,
    dependentControls: [
      {
        id: EReportControlId.METRICS_FILTER,
      },
    ],
    info: REPORT_METRIC_INFO[uid],
  };
};
